import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { TokenStorageService } from './token.service';

@Injectable({
  providedIn: 'root'
})
export class RepoService {
  constructor(private http: HttpClient,private tokenStorageService:TokenStorageService) { }

  async getFarmMachinaryRepo(obj) {
    let body = {
      target: "farmmachinery",
      query: obj,
      lKey: "Utilities"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.ecommerceReadGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        resolve(result)
      }, reject);
    })
  }
  async getFarmMachinaryRepocount(obj) {
    let body = {
      target: "farmMachineryRepo",
      query: obj,
      lKey: "Utilities"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.ecommerceReadGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        resolve(result)
      }, reject);
    })
  }
  async createMachinery(Product) {
    let body = {
      target: "farmmachinery",
      source: Product,
      lKey: "Utilities"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.ecommerceWriteGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        resolve(result)
      }, reject);
    })
  }
  async updateFarmMachinary(machine, uuid) {
    let obj = {
      machineryId: uuid,
      group: machine.group
    }
    let body = {
      target: "farmmachinery",
      source: machine,
      query: obj,
      lKey: "Utilities"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.ecommerceWriteGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        resolve(result)
      }, reject);
    })
  }
  saveFarmMachinary() {

  }
}
